import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PersonalInformationEditCardType} from "./personal-information-edit-card-type.enum";
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {PersonalInformationEditCardUtil} from "./personal-information-edit-card.util";

@Component({
  selector: 'app-personal-information-edit-card',
  templateUrl: './personal-information-edit-card.component.html',
  styleUrls: ['./personal-information-edit-card.component.css']
})
export class PersonalInformationEditCardComponent implements OnInit {

  @Input() type!: PersonalInformationEditCardType;
  @Input() values: Array<string> = [];
  @Input() currentUserId: string | null = null;
  @Input() formGroup!: FormGroup;
  @Input() isEditing = false;

  protected oldPassword: string = '';

  @Output() onClickSave: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() onClickCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onClickEdit: EventEmitter<PersonalInformationEditCardType | null> = new EventEmitter();

  constructor(
    private readonly personalInformationEditCardUtil: PersonalInformationEditCardUtil
  ) {
  }

  ngOnInit(): void {
    this.values = this.getControlsByType().map(control => control?.value);
  }

  get name() {
    return this.type;
  }

  get value() {
    return this.values.length > 1 ? this.values.join(' ') : this.values[0];
  }

  get isSpecificForm(): boolean {
    return this.type === PersonalInformationEditCardType.PASSWORD
      || this.type === PersonalInformationEditCardType.PHONE
  }

  protected startEdit() {
    this.isEditing = true;
    this.onClickEdit.emit(this.type);
  }

  protected cancelEdit() {
    this.isEditing = false;
    this.onClickCancel.emit();
    this.onClickEdit.emit(null);
  }

  protected saveChanges() {
    this.isEditing = false;
    this.onClickSave.emit(this.formGroup);
    this.onClickEdit.emit(null);
  }

  protected getControlsByType(): AbstractControl<any, any>[] {
    switch (this.type) {
      case PersonalInformationEditCardType.PHONE:
        return [this.formGroup.get('phone')!];
      case PersonalInformationEditCardType.PASSWORD:
        return [this.formGroup.get('password')!];
      case PersonalInformationEditCardType.NAME:
        return [this.formGroup.get('firstName')!, this.formGroup.get('lastName')!];
      case PersonalInformationEditCardType.EMAIL:
        return [this.formGroup.get('email')!];
    }
  }

  protected formatLabel(formControl: AbstractControl) {
    let formControlName: string = this.getControlName(formControl);
    return this.personalInformationEditCardUtil.getFormattedLabelForFormControl(formControlName)
  }

  protected castToFormControl(formControl: AbstractControl<any, any>): FormControl {
    return formControl as FormControl;
  }

  protected getControlName(control: AbstractControl): string {
    return Object.keys(this.formGroup.controls)
      .find(name => control == this.formGroup.controls[name])!;
  }

  protected getPlaceholderByFormControl(formControl: AbstractControl<any, any>) {
    return `Enter ${this.formatLabel(formControl).toLowerCase()}`
  }

  protected readonly PersonalInformationEditCardType = PersonalInformationEditCardType;
}
